import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/smartguy/node_modules/.pnpm/next@15.5.7_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/app-dir/link.js");
